/**
 * AdminList
 */

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Alert } from 'react-bootstrap';
import Spinner from 'components/Spinner/index.jsx';
import usePagination from 'components/Pagination/usePagination.jsx';
import AdminTable from './AdminTable.js';

const PAGESIZE = 10;

function AdminList(props) {
  const { resetKey, items, list, emptyMessage, header, renderRow } = props;
  const { ready, loading, loadMore, totalCount } = items;
  const count = loadMore ? totalCount : list.length;
  const { slice, Paginator, setPage } = usePagination(count, PAGESIZE, loadMore);
  useEffect(() => {
    setPage(0);
  }, [resetKey]);

  return ready && list.length === 0 ? (
    <Alert variant="info" className="m-4"><FormattedMessage {...emptyMessage} /></Alert>
  ) : (
    <>
      <AdminTable responsive>
        {header}
        <tbody>
          {slice(list).map(renderRow)}
        </tbody>
      </AdminTable>
      {loading && <Spinner />}
      <Paginator />
    </>
  );
}

AdminList.propTypes = {
  list: PropTypes.array,
  resetKey: PropTypes.string,
  items: PropTypes.object,
  title: PropTypes.object,
  intro: PropTypes.object,
  control: PropTypes.node,
  emptyMessage: PropTypes.object,
  header: PropTypes.node,
  renderRow: PropTypes.func,
};

export default AdminList;
